import React from 'react';
import { Grid } from '@material-ui/core';
import { StyledGrid } from './BrandingSection.styled';
import InputColor from '../../../Shared/InputColor';
import { Row, StyledPaperContainer, StyledSectionTitle, StyledSwitch } from '../../PlusWebsiteEditor.styles';
import { WebsiteConfiguration } from '../../types/websiteConfiguration';
import { BlurHandler, DeepFieldErrorGetter } from '../../types/handlers';

type Props = WebsiteConfiguration['branding'] & { onChange: (field: string, value: string | boolean) => void; onBlur: BlurHandler; getError?: DeepFieldErrorGetter };

const BrandingSection = ({ colors, display_powered_by, onChange, onBlur, getError }: Props) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.name, e.target.value.toLowerCase());

  return (
    <StyledPaperContainer>
      <StyledSectionTitle>Branding</StyledSectionTitle>
      <StyledGrid container spacing={16}>
        <Grid item xs={6}>
          <InputColor name="colors.primary" placeholder="#48617F" label="Primary" value={colors?.primary || ''} onChange={handleInputChange} onBlur={onBlur} error={getError?.('colors.primary')} />
        </Grid>
        <Grid item xs={6}>
          <InputColor name="colors.light_primary" placeholder="#F7FBFD" label="Light primary" value={colors?.light_primary || ''} onChange={handleInputChange} onBlur={onBlur} error={getError?.('colors.light_primary')} />
        </Grid>
        <Grid item xs={6}>
          <InputColor name="colors.secondary" placeholder="#7CB0F9" label="Secondary" value={colors?.secondary || ''} onChange={handleInputChange} onBlur={onBlur} error={getError?.('colors.secondary')} />
        </Grid>
        <Grid item xs={6}>
          <InputColor name="colors.tertiary" placeholder="#57BFA9" label="Tertiary" value={colors?.tertiary || ''} onChange={handleInputChange} onBlur={onBlur} error={getError?.('colors.tertiary')} />
        </Grid>
      </StyledGrid>
      <Row>
      <StyledSwitch onChange={(_: any, checked: boolean) => onChange('display_powered_by', checked)} label="Display 'Powered by Healthera'" checked={!!display_powered_by} value={!!display_powered_by} />
      </Row>
    </StyledPaperContainer>
  );
};

export default BrandingSection;
